import {
    FormAddonGroup,
    FormAddonQuantities,
} from '@/features/pos/components/ProductConfigurationModal/form/types'
import { AddonGroup } from '@/features/pos/components/ProductConfigurationModal/types'

export const toFormAddonGroup = (
    addonGroup: AddonGroup,
    addonQuantities: FormAddonQuantities
): FormAddonGroup => {
    return {
        id: addonGroup.id,
        type: addonGroup.type,
        addonQuantities,
        minQuantity: addonGroup.minQuantity,
    }
}
